import React, { useEffect, useRef } from 'react'
import { runSaga } from 'store/sagaMiddleware'
import { init } from 'routes/Home/sagas'
import { useSelector } from 'react-redux'
import useChannel from 'hooks/useChannel'
import { Task } from 'redux-saga'

const HomeDataProvider: React.FC = () => {
  const taskRef = useRef<Task>()

  const isLoaded = useSelector<any, boolean>(state => state['view-home'].view.isLoaded)
  const isLoading = useSelector<any, boolean>(state => state['view-home'].view.isLoading)

  useEffect(() => {
    if (!isLoaded && !isLoading) {
      if (taskRef.current) {
        taskRef.current.cancel()
      }

      taskRef.current = runSaga(init)
    }
  }, [isLoaded, isLoading])

  useEffect(() => {
    return () => {
      if (taskRef.current) {
        taskRef.current.cancel()
      }
    }
  }, [])

  useChannel('landingPage')
  useChannel('document-template-sources')

  return null
}

export default HomeDataProvider